import { sendWebsocketMessage } from '../../../../../App';

export function addSavedAlertTradePlanConfiguration({
  configurationName,
  json,
}) {
  const msg = {
    messageType: 'addSavedAlertTradePlanConfiguration',
    configurationName,
    alertJson: json,
  };
  sendWebsocketMessage(msg);
}
